import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon, { Icons } from '../Icon/Icon';

import './InlineNotice.scss';

const iconSize = 24;

const InlineNotice = ({ className, type = 'warning', icon = 'EXCLAMATIONMARK_CIRCLE', children }) => {
	return (
		<div className={classNames('InlineNotice', className, type)}>
			<Icon className='InlineNotice-icon' width={iconSize} height={iconSize} type={Icons[icon]} />
			<div className='InlineNotice-children'>{children}</div>
		</div>
	);
};

InlineNotice.propTypes = {
	type: PropTypes.oneOf(['success', 'warning', 'error', 'notification', 'neutral']),
	icon: PropTypes.string,
	children: PropTypes.node,
};

export default InlineNotice;
